window.Sparkle ??= {};
window.Sparkle.AssetCropper ??= {};

Sparkle.AssetCropper.SafeFrame = class SafeFrame {
  constructor(aspectRatio, label, options) {
    this.render = this.render.bind(this);
    this._containerAspectRatio = this._containerAspectRatio.bind(this);
    this._buildSVGLabel = this._buildSVGLabel.bind(this);
    this.aspectRatio = aspectRatio;
    this.options = jQuery.extend({ color: "white", textColor: "black" }, options);
    this.el = jQuery("<div>", { class: "safe-frame" });
    this.el.css({
      position: "absolute",
      top: "0",
      left: "0",
      height: "100%",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
    });

    this.stencil = jQuery('<svg><circle x="0" y="0"/></svg>').attr({ class: "safe-frame-stencil" }); // SVG needs something in it to retain size
    this.stencil.css({
      border: "1px dashed",
      borderColor: this.options.color,
    });
    // Set the natural shape of the frame
    this.stencil.attr({
      height: 100,
      width: 100 * this.aspectRatio,
    });

    if (label) {
      this.stencil[0].appendChild(this._buildSVGLabel(label));
    }
    this.el.append(this.stencil);
  }

  render() {
    const containerAspectRatio = this._containerAspectRatio();
    if (Math.round(containerAspectRatio * 100) === Math.round(this.aspectRatio * 100)) {
      if (this.aspectMode !== 1) {
        this.stencil.css({ width: "100%", height: "100%", borderWidth: "0" });
      }
      this.aspectMode = 1;
    } else if (containerAspectRatio < this.aspectRatio) {
      if (this.aspectMode !== 2) {
        this.stencil.css({ width: "100%", height: "auto", borderWidth: "1px 0" });
      }
      this.aspectMode = 2;
    } else {
      if (this.aspectMode !== 3) {
        this.stencil.css({ width: "auto", height: "100%", borderWidth: "0px 1" });
      }
      this.aspectMode = 3;
    }

    return self;
  }

  // PRIVATE

  _containerAspectRatio() {
    return this.el.width() / this.el.height();
  }

  _buildSVGLabel(text) {
    const label = document.createElementNS("http://www.w3.org/2000/svg", "text");
    label.setAttribute("y", "100%");
    label.setAttribute("x", "0");
    label.setAttribute("transform", "translate(1 -2)");
    label.setAttribute("class", "safe-frame-label");
    label.style.font = "italic 13px sans-serif";
    label.style.fill = this.options.textColor;
    label.style.stroke = "white";
    label.style.strokeWidth = "3px";
    label.style.paintOrder = "stroke";
    label.style.strokeLinejoin = "round";
    label.append(text);

    return label;
  }
};
